module.exports = __webpack_public_path__ + "img/checkedCollision.001a4da5.png";